import { BaseSyntheticEvent, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Input } from "../../../../components/Input/Input";
import useModals from "../../../../hooks/useModals";
import { ModalImagemCropped } from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import { AggregatorClassification } from "../../AggregadorCategory/aggregadorCategory.type";
import { LojaAgregador } from "../../lojas/type";
import { DinamicPageCreate } from "../dinamyc-pages.types";
import { i18n } from "../../../../translate/i18n";


type Props = {
    form: DinamicPageCreate;
    updateForm: (field: fieldsUpdateForm, value: string | number | boolean | File) => void
    stores: LojaAgregador[]
    classification: AggregatorClassification[]
    blockSlug:boolean
}
type fieldsUpdateForm = 'title' | 'description' | 'aggregatorClassificationId' | 'storeId' | 'order' | 'seoTitle' | 'seoDescription' | 'shareImage' | 'slug' | 'status'

export function TabInfoPage({ form, updateForm, stores, classification, blockSlug = false }: Props) {

    const { showImageCropped } = useModals()
    const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
    const [imageCrop, setImageCrop] = useState<string | null>('')
    const [isCropped, setCropper] = useState<any>(null)


    function getImagetoCrop(file: File) {
        setOriginalImageFile(file) // Armazenar arquivo original
        const url = URL.createObjectURL(file)
        setImageCrop(url)
        showImageCropped()
    }

    const getCropData = async () => {
        if (isCropped) {
            const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
                .then((res) => res.blob())
                .then((blob) => {
                    return new File([blob], 'newAvatar.png', { type: 'image/png' })
                })

            updateForm('shareImage', file ?? '')
            setImageCrop('')
        }
    }

    const useOriginalImage = () => {
        if (originalImageFile) {
            updateForm('shareImage', originalImageFile ?? '')
            setImageCrop('')
        }
    }

    const handleSelectedSize = (width: number, height: number) => {
        if (originalImageFile) {
            // Criar uma cópia do arquivo original com metadados especiais
            const imageWithFormat = Object.assign(originalImageFile, {
                _formatData: {
                    file: originalImageFile,
                    width: width,
                    height: height,
                    isFormatted: true,
                },
            })

            updateForm('shareImage', imageWithFormat ?? '')
            setImageCrop('')
        }
    }

    return (
        <section className='card border mb-5'>
            <div className='card-header min-h-60px'>
                <div>
                    <h2 className='card-title fs-4 fw-bolder mb-1'>{i18n.t('agregador_dinamic_page.tabs.general_title')}</h2>
                    <p className='text-muted fw-bold fs-7 mb-0'>{i18n.t('agregador_dinamic_page.tabs.general_description')}</p>
                </div>
            </div>
            <div className='card-body'>
                <div className='row g-5'>
                    <div className='col-6'>
                        <Input
                            inputAttr={{
                                type: 'text',
                                className: 'form-control',
                            }}
                            label={i18n.t('agregador_dinamic_page.form.title_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.title_placeholder')}
                            value={form.title}
                            change={(value: string) => updateForm('title', value)} />

                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{
                                type: 'select',
                                className: 'form-control',
                            }}
                            label='Categoria'
                            placeholder='Selecione uma categoria para vincular essa página'
                            value={form.aggregatorClassificationId}
                            options={[{ select: 'Selecione uma categoria', value: 0 }, ...classification.map(c => ({ select: c.name, value: c.id }))]}
                            change={(value: any) => {
                                updateForm('aggregatorClassificationId', value)
                            }}
                        />
                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{
                                type: 'textarea',
                                className: 'form-control',
                            }}
                            label={i18n.t('agregador_dinamic_page.form.description_label')}
                            maxCaracteres={350}
                            placeholder={i18n.t('agregador_dinamic_page.form.description_placeholder')}
                            value={form.description}
                            change={(value: string) => updateForm('description', value)} />

                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{
                                type: 'select',
                                className: 'form-control',
                            }}
                            label={i18n.t('agregador_dinamic_page.form.local_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.local_placeholder')}
                            value={form.storeId}
                            options={[{ select: i18n.t('aggregador_publicity.form.local_placeholder'), value: 0 }, ...stores.map(c => ({ select: c.name, value: c.id }))]}
                            change={(value: number) => updateForm('storeId', value)}
                        />
                        
                    </div>
                    <div className='col-3'>
                        <Input
                            inputAttr={{ type: 'number', className: 'form-control' }}
                            label={i18n.t('agregador_dinamic_page.form.order_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.order_placeholder')}
                            value={form.order}
                            change={(value: number) => updateForm('order', value)}
                        />
                    </div>
                    <div className='col-7'>
                        <Input
                            inputAttr={{ type: 'text', className: 'form-control' }}
                            label={i18n.t('agregador_dinamic_page.form.slug_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.slug_placeholder')}
                            value={form.slug}
                            disabled={blockSlug}
                            change={(value: string) => updateForm('slug', value)}
                        />
                    </div>
                    <div className='col-2 d-flex align-items-end'>
                        <Input
                            inputAttr={{ type: 'checkbox' }}
                            label={i18n.t('agregador_dinamic_page.form.status_label')}
                            checkSwift={true}
                            checked={form.status}
                            change={(value: boolean) => updateForm('status', value)}
                        />
                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{ type: 'text', className: 'form-control' }}
                            label={i18n.t('agregador_dinamic_page.form.title_seo_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.title_seo_placeholder')}
                            value={form.seoTitle}
                            change={(value: string) => updateForm('seoTitle', value)}
                        />
                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{ type: 'textarea', className: 'form-control' }}
                            label={i18n.t('agregador_dinamic_page.form.description_seo_label')}
                            placeholder={i18n.t('agregador_dinamic_page.form.description_seo_placeholder')}
                            value={form.seoDescription}
                            maxCaracteres={350}
                            change={(value: string) => updateForm('seoDescription', value)}
                        />
                    </div>
                    <div className='col-6'>
                        <Input
                            inputAttr={{ type: 'image-agregador' }}
                            label={i18n.t('agregador_dinamic_page.form.share_image_label')}
                            smalltext={i18n.t('agregador_dinamic_page.form.share_image_small_text')}
                            imagemBackgroundDefault={'640x240'}
                            width='200'
                            height='100'
                            value={form.shareImage}
                            placeholder='Selecione uma imagem para compartilhamento'
                            maxFiles={1}
                            change={(value: BaseSyntheticEvent) => {
                                const file = value ? value.target.files[0] : null;
                                if (!file) {
                                    updateForm('shareImage', '')
                                    return
                                }


                                const sizeInBytes: number = file ? file.size : 0;

                                const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                                const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                                if (sizeInMB > 2) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Erro',
                                        text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                                    });
                                    return;
                                }
                                getImagetoCrop(file as File)
                            }}
                        />
                    </div>

                </div>
            </div>
            <ModalImagemCropped
                imageCrop={imageCrop}
                setCropper={setCropper}
                getCropData={getCropData}
                onUseOriginalImage={useOriginalImage}
                onUseSelectedSize={handleSelectedSize}
                croppedOptions={[{ width: 980, height: 420, value: '980x420' }]}
            />
        </section>
    )
}